import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import {
  GET_WOWCHER,
  VIEW_WOWCHER,
  GET_WOWCHER_ERROR,
} from '../../config/text/text';
import ErrorTrackingService from '../../helpers/errorTrackingService';
import { openPdf } from '../../helpers/pdf';
import { generateVoucher } from '../../services/vouchers';
import CTAButton from '../_generic/button/CTAButton';
import LinkButton from '../_generic/button/LinkButton';
import useToast from '../_generic/toast/UseToast';

export const GetVoucherButton = ({ voucher, className }) => {
  const [pdf, setPdf] = useState({ arrayBuffer: null, href: null });
  const [working, setWorking] = useState(false);
  const toast = useToast();

  const getVoucher = async () => {
    setWorking(true);
    try {
      const result = await generateVoucher(voucher.voucherCode);
      setPdf(result);
    } catch (error) {
      toast.addToast(
        GET_WOWCHER_ERROR[process.env.NEXT_PUBLIC_BRAND],
        'toast-error',
      );
      ErrorTrackingService.logError(error);
    }
    setWorking(false);
  };

  if (pdf.href) {
    return (
      <LinkButton className={className} href={pdf.href}>
        {VIEW_WOWCHER[process.env.NEXT_PUBLIC_BRAND]}
      </LinkButton>
    );
  }

  if (pdf.arrayBuffer) {
    return (
      <CTAButton
        className={classNames('secondary-button', className)}
        onClick={() => openPdf(pdf.arrayBuffer, 'voucher')}
      >
        {VIEW_WOWCHER[process.env.NEXT_PUBLIC_BRAND]}
      </CTAButton>
    );
  }

  return (
    <CTAButton
      className={classNames('primary-button', className)}
      disabled={working}
      onClick={getVoucher}
    >
      {GET_WOWCHER[process.env.NEXT_PUBLIC_BRAND]}
    </CTAButton>
  );
};

GetVoucherButton.propTypes = {
  className: PropTypes.string,
  voucher: PropTypes.object,
};
